import {createSelector} from 'reselect';

export const getCollaborateState = (state) => state.tripboard.collaborate;

export const getCountState = createSelector(
    getCollaborateState,
    (state) => state.count
);

export const getModalState = createSelector(
    getCollaborateState,
    (state) => state.modal
);


// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/selectors.js